import { 
    holiday_holiday_create,
    holiday_list_get,
    holiday_holiday_update,
    holiday_date_get
} from '../../Models/Management/Holidays_Model';

//======== CREATE ======
export const onCreateHoliday = (data) => {
    return new Promise((resolve, reject) => {
        holiday_holiday_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== GET ======
export const onGetHoliday = (data) => {
    return new Promise((resolve, reject) => {
        holiday_list_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== GET ======
export const onGetHolidayByDate = (data) => {
    return new Promise((resolve, reject) => {
        holiday_date_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== UPDATE ======
export const onUpdateHoliday = (data) => {
    return new Promise((resolve, reject) => {
        holiday_holiday_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}